<template>
  <div class="app-booking-form-total-info">
    <div v-if="buyNowFlow" class="buy-now-flow">
      <div class="text-area">
        <b class="label">Total</b>
        <span class="quantity">{{ amountFormatted }} {{ quantityFormatted }}</span>
      </div>
      <div class="value-area">
        <span class="value">{{ total }}</span>
      </div>
    </div>

    <div v-else class="on-demand-flow">
      <span class="info">{{ amountFormatted }} for up to {{ capacity }} pax</span>
    </div>
  </div>
</template>

<script>
import { EXPERIENCE_BOOKING_TYPE } from '@/helpers/experience';
import { formatCentsToCurrency } from '@/helpers/money';

export default {
  props: {
    type: {
      type: String,
      default: EXPERIENCE_BOOKING_TYPE.buyNow,
    },
    free: {
      type: Boolean,
      default: false,
    },
    amount: {
      type: Number,
      default: null,
    },
    currencyCode: {
      type: String,
      default: null,
    },
    quantity: {
      type: Number,
      default: 1,
    },
    capacity: {
      type: Number,
      default: null,
    },
  },
  computed: {
    buyNowFlow() {
      return this.type === EXPERIENCE_BOOKING_TYPE.buyNow;
    },
    amountFormatted() {
      if (this.free || !this.amount) {
        return null;
      }

      return formatCentsToCurrency(this.amount, this.currencyCode);
    },
    quantityFormatted() {
      return this.free ? null : `x${this.quantity}`;
    },
    total() {
      if (this.free) {
        return 'Free';
      }

      if (!this.amount) {
        return null;
      }

      return formatCentsToCurrency(this.amount * this.quantity, this.currencyCode);
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.app-booking-form-total-info {
  .buy-now-flow {
    display: flex;
    justify-content: space-between;
    gap: 16px;

    .text-area {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }

    .label {
      font-weight: 600;
      font-size: 18px;
      letter-spacing: 1px;
    }

    .quantity {
      font-size: 16px;
      color: vars.$c-dark-5b;
    }

    .value {
      color: vars.$c-accent-07bfe;
      font-size: 18px;
      font-weight: 700;
      letter-spacing: 3px;
      text-transform: uppercase;
    }
  }

  .on-demand-flow {
    .info {
      font-size: 18px;
    }
  }
}
</style>
